import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button ,Glyphicon,ToggleButtonGroup ,ToggleButton} from "react-bootstrap";

import {ActionsDisplay} from "./ActionsDisplay"
import ActionCreate from './ActionCreate'
import ReactDragList from 'react-drag-list'

const log = (type) => console.log.bind(console, type);


const ActionList={

    buzzer:{
        "icon":"bell",
        "name":"Buzzer",
        "description":"Control the internal buzzer",
    },

    say:{
      icon:"volume-up",
      name:"Say Text",
      description:"Send text to the speakers",
    },

    music:{
      icon:"equalizer",
      name:"Play a mp3",
      description:"Play an mp3 file",
    },



    delay:{
      icon:"time",
      name:"Time Delay",
      description:"Delay action by a set period of time",
    },





    "buildString":{
      icon:"wrench",
      name:"Build String",
      description:"Build a String from text and data",
    },

    "sendString":{
      icon:"wrench",
      name:"Send Remote String",
      description:"Send a string to another altiom",
    },

    "485send":{
      icon:"send",
      name:"Transmit 485",
      description:"Transmit data out of 485 port",
    },

    "log":{
      icon:"align-left",
      name:"Logging",
      description:"Add custom log entry",
    },

    "outputCtrl":{
      icon:"send",
      name:"Output Device",
      description:"Control an output device",
  },

    "varCtrl":{
      icon:"equalizer",
      name:"Alter Variables",
      description:"Set ,increment and decrement a variable value",
    },


    "macro":{
      icon:"random",
      name:"Run/Stop action",
      description:"Run another or stop another action",
    },
    "event":{
      icon:"random",
      name:"Enable/Disable Event",
      description:"Enable/Disable event",
    },

    "schedule":{
      icon:"time",
      name:"Enable/Disable schedule",
      description:"Enable/Disable schedule",
    },


    "alertlist":{
      icon:"send",
      name:"Alert multiple contacts",
      description:"Send email alerts to a list of contacts",
    },



    "system":{
      icon:"flash",
      name:"Reboot / Reset Events",
      description:"Reboot cycle network, recalcualte event states",
    },


    "report":{
      icon:"send",
      name:"Send out report",
      description:"Send generated report to users",
    },

    "getimage":{
      icon:"camera",
      name:"Capture Image",
      description:"Capture an image from a camera url",
    },


    "script":{
      icon:"glass",
      name:"Script",
      description:"Run a python script",
    },


    "sipcall":{
      icon:"send",
      name:"SIP call",
      description:"Make a call to sip phone",
  },


    "Custom":{
      icon:"glass",
      name:"Custom",
      description:"Blank fro creating a custom action",
    },


    "dali":{
      icon:"glass",
      name:"DALI",
      description:"Send out DALI command",
    },

    "modbus":{
      icon:"glass",
      name:"MODBUS",
      description:"Send out MODBUS 458",
    }


}
//This can be a file that the server references :)



export default class MacroCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        vars:props.vars,
        showEdit:false,
        editIndex:0,
        newAction:false,
        addNew:false,
        nameEdit:false,
        redraw:true,
        macroList:{"enum": [], "enumNames": []},
        varlist:{"enum": [], "enumNames": []},
        outList:{"enum": [], "enumNames": []},
        schList:{"enum": [], "enumNames": []},
        eventList:{"enum": [], "enumNames": []}
      };

    }
    componentWillMount() {
      console.log("Macro Create Mount")
  this.setState({data:this.props.data})
    this.setState({vars:this.props.vars})
        console.log(this.state.data)
console.log(this.props.data)

    let macrolist=this.state.macroList
    //console.log(this.props.macros)
    for (var key in this.props.macros){
      macrolist.enum.push(key)
      macrolist.enumNames.push(this.props.macros[key].name)
    }

      this.setState({macroList:macrolist})


      let schList=this.state.schList

      for (var key in this.props.schedule){
        schList.enum.push(key)
        schList.enumNames.push(this.props.schedule[key].name)
      }

        this.setState({schList:schList})


        let eventList=this.state.eventList

        for (var key in this.props.events){
          eventList.enum.push(key)
          eventList.enumNames.push(this.props.events[key].name)
        }

        this.setState({eventList:eventList})



      let varlist=this.state.varlist




      for (var key in this.props.vars){
        if(this.props.vars[key]["type"]=="CONTACT_LIST"){
          varlist.enum.push(this.props.vars[key]["id"])
          varlist.enumNames.push(this.props.vars[key].name)
        }
      }
      console.log(varlist)
      this.setState({varlist:varlist})
      let outlist=this.state.outList
      outlist.enum.push("")
      outlist.enumNames.push("Not set")
      for (var i=0;i<this.props.outputs.length;i++){
        if(this.props.outputs[i]["type"]=="ON/OFF"){
          outlist.enum.push(this.props.outputs[i]["id"])
          outlist.enumNames.push(this.props.outputs[i].name)
        }
      }

      this.setState({outlist:outlist})



    }





    test=()=>{
      console.log("Running Test")
      console.log(this.state)
      console.log(this.props.data)
    }





    editaction=(index)=>{
      console.log("EDIT:"+index)
      this.setState({showEdit:false})
          this.setState({editIndex:index})
      this.setState({showEdit:true})
      console.log(this.state)




    }


    delAction=(index)=>{
      let temp=this.state.data
      console.log("Del Action")
      if(temp.actions.length>1)
        temp.actions.splice(index, 1)
      else{
        temp.actions=[]

      }
      this.setState({data:temp})

    }



    newAction=(action)=>{
      console.log("New Action:"+action)

      let temp=this.state.data
      temp.actions.push({"cmd":action})
      this.setState({data:temp})
      console.log(temp)
      this.editaction(temp.actions.length-1)


    }
    actionCallback=(cmd,action)=>{
      console.log("Callback")
      console.log("Callback")
      console.log(cmd)
      let temp=this.state.data
      if(cmd=="cancel"){
        console.log(this.state.newAction)
          if (this.state.newAction==true){
              temp.actions.splice(this.state.editIndex, 1);
            this.setState({data:temp})
          }
            this.setState({showEdit:false})
      }

      if(cmd=="submit"){
          console.log("saved")
          //Update the action with the new data
          this.setState({newAction:false})
          temp.actions[this.state.editIndex]=action
          this.setState({data:temp})
          this.setState({newAction:false})
          this.setState({showEdit:false})

      }

    }

editMacroName=()=>{

this.setState({nameEdit:true})


}
macroNameChange=(event)=>{
  console.log(event)
  let temp=this.state.data
  temp.name=event.target.value
  this.setState({data: temp});
}

saveMacroName=()=>{
  this.setState({nameEdit:false})




}




    startNewAction=()=>{
      console.log("Start New Action create")
  this.setState({newAction:true})


    }

cancelNewAction=()=>{
  console.log("Start New Action create")
this.setState({newAction:false})


}

handleDragUpdate= (evt, updated) => {

      console.log(evt); // tslint:disable-line
      console.log(updated); // tslint:disable-line
      let temp=this.state.data
      console.log("Updating data")
    //  temp.actions=updated
    //  this.setState({data:temp})
      this.setState({redraw:!this.state.redraw})
      // this.setState({
      //   dataSource: [...updated, {
      //     color: '#FFAA00',
      //     title: 'Added Engineer',
      //     text: 'Added Engineer',
      //   }]
      // })
}



runMacro(){

    let d={"cmd":"macro","type":"run","id":this.props.macro_key}
      this.props.sendmsg(d)
}

cancelMacro(){
  this.props.callback("close",this.props.macro_key)


}

saveMacro(){
  console.log("~~~~~~~~~~~~~~~~~~~SAVE MACRO~~~~~~~~~~~~~~~~~~~~~~")
  console.log(this.state.data)

  let d={
    cmd:"macro",
    type:"update",
    index:this.props.macro_key,
    data:this.state.data
  }
  this.props.sendmsg(d)
  this.props.callback("closeSuccess",this.props.macro_key)
}

toggleNIoption=()=>{
  console.log("Toggle NI option?")
  let temp=this.state.data
  if ("interfaceOption" in temp){
      temp.interfaceOption=!temp.interfaceOption
  }
  else{
    temp["interfaceOption"]=true
  }
  console.log(temp)
  this.setState({data:temp})

}
    render(){


      let tempkey=this.props.macro_key

      if(this.state.showEdit==true){


        return(<div className="spacedout">
              <ActionCreate sendmsg={this.props.sendmsg} callback={this.actionCallback} data={this.state.data.actions[this.state.editIndex]} macrolist={this.state.macroList} outputs={this.state.outList} vars={this.state.varlist} events={this.state.eventList} schedule={this.state.schList}></ActionCreate>
              </div>)

      }


      if (this.state.showEdit==false && this.state.newAction==false){


        if(this.state.redraw==true){
        return(<div className="spacedout" key="asdf">
          {this.state.nameEdit ? (
            <div>
            <input value={this.state.data.name} onChange={this.macroNameChange}></input>
            <Button onClick={()=>this.saveMacroName()}>Done</Button>
            &nbsp;<b>key:</b> <i>{tempkey}</i>
              <br/>
              <br/>
            </div>
          ):(
            <div>
            <Button className="pull-right" bsSize="xsmall" onClick={()=>this.runMacro()}>
            <Glyphicon glyph="play" />
            </Button>
          <h3 title={this.props.macro_key} >{this.state.data.name}&nbsp;<Glyphicon onClick={()=>this.editMacroName()} title="Edit name" className="iconBut" glyph="pencil" /></h3>
          <h4  >{this.state.data.description}</h4></div>)
          }
          <ReactDragList
                   dataSource={this.state.data.actions}
                   row={(a, i) => (
                    <div className="macroAction" key={i} ><ActionsDisplay  data={a} vars={this.state.varlist} macros={this.props.macros} outputs={this.props.outputs} events={this.props.events} schedule={this.props.schedule}></ActionsDisplay><div className="pull-right"><Button onClick={()=>this.editaction(i)}>Edit</Button><Button onClick={()=>this.delAction(i)}>Delete</Button></div></div>
                   )}
                   handles={false}
                   dragClass="drag-item"
                   className="simple-drag"
                   rowClassName="simple-drag-row"
                   onUpdate={this.handleDragUpdate}
                 />

                 <i className="pull-right">

                 <ToggleButtonGroup type="radio" name="options" value={this.state.data.interfaceOption} onChange={()=>this.toggleNIoption()}>
                       <ToggleButton value={true}>Visible on Nurse Interface</ToggleButton>
                       <ToggleButton value={false}>Hide on Nurse Interface</ToggleButton>
                   </ToggleButtonGroup>
{/*
                 {this.state.data.interfaceOption==true ? (<p title="tap to change" onClick={()=>this.toggleNIoption()}>Shown on Nurse Interface</p>):(<p title="tap to change" onClick={()=>this.toggleNIoption()}>Hidden on Nurse Interface</p>)}
                 */}
                 </i>
        <Button onClick={()=>this.startNewAction()}>Add Action</Button><br /><br /><Button onClick={()=>this.saveMacro()}>Save</Button>
        <Button onClick={()=>this.cancelMacro()}>Cancel</Button>
          </div>)}

          else{
          return(<div className="spacedout"  key="fdsa">
            {this.state.nameEdit ? (
              <div>
              <input value={this.state.data.name} onChange={this.macroNameChange}></input>
              <Button onClick={()=>this.saveMacroName()}>Done</Button>
                <br/>
                <br/>
              </div>
            ):(
              <div>
              <Button className="pull-right" bsSize="xsmall" onClick={()=>this.runMacro()}>
              <Glyphicon glyph="play" />
              </Button>
            <h3 title={this.props.macro_key} >{this.state.data.name}&nbsp;<Glyphicon onClick={()=>this.editMacroName()} title="Edit name" className="iconBut" glyph="pencil" /></h3>
            <h4  >{this.state.data.description}</h4></div>)
            }
            <ReactDragList
                     dataSource={this.state.data.actions}
                     row={(a, i) => (
                      <div className="macroAction" key={i} ><ActionsDisplay  data={a} vars={this.state.varlist} macros={this.props.macros} outputs={this.props.outputs} events={this.props.events} schedule={this.props.schedule}></ActionsDisplay><div className="pull-right"><Button onClick={()=>this.editaction(i)}>Edit</Button><Button onClick={()=>this.delAction(i)}>Delete</Button></div></div>
                     )}
                     handles={false}
                     dragClass="drag-item"
                     className="simple-drag"
                     rowClassName="simple-drag-row"
                     onUpdate={this.handleDragUpdate}
                   />

                   <i className="pull-right">
                   {this.state.data.interfaceOption==true ? (<p title="tap to change" onClick={()=>this.toggleNIoption()}>Shown on Nurse Interface</p>):(<p title="tap to change" onClick={()=>this.toggleNIoption()}>Hidden on Nurse Interface</p>)}
                   </i>


          <Button onClick={()=>this.startNewAction()}>Add Action</Button><br /><br /><Button onClick={()=>this.saveMacro()}>Save</Button>
          <Button onClick={()=>this.cancelMacro()}>Cancel</Button>
            </div>)
          }
      }


      if(this.state.newAction==true){
          return (<div className="spacedout">
          <h3>Select an Action</h3>
            <div className="flexit">
          {Object.keys(ActionList).map((a,i)=><div title={ActionList[a].description} key={i} class="actionItem" onClick={()=>this.newAction(a)}><div class="actionOption"><Glyphicon glyph={ActionList[a].icon} /></div><span>{ActionList[a].name}</span></div>)}
            </div>

<center><Button onClick={()=>this.cancelNewAction()}>Cancel</Button></center>
            </div>)



      }








    }

}

/*
if (this.state.showEdit==false && this.state.newAction==false){
  return(<div className="spacedout">
    <h3 title={this.props.macro_key} >{this.state.data.name}</h3>
    <h4  >{this.state.data.description}</h4>
    {this.state.data.actions.map((a,i)=><div className="macroAction"><b>{i+1}:</b><ActionsDisplay  data={a} vars={this.state.vars} ></ActionsDisplay><div className="pull-right"><Button onClick={()=>this.editaction(i)}>Edit</Button><Button onClick={()=>this.delAction(i)}>Delete</Button></div></div>)}
  <Button onClick={()=>this.startNewAction()}>ADD</Button>
    </div>)
}
*/
//



// WEBPACK FOOTER //
// ./src/programmerComponents/MacroCreate.js